import React from 'react';

const AngleRight = ({ onClick, customStyles = {} }) => {
  const styles = { fill: '#b2b2b2', width: '10px', cursor: 'pointer' };
  return (
    <svg
      onClick={onClick}
      viewBox="0 0 90.83 153.32"
      style={{ ...styles, ...customStyles }}
    >
      <polygon
        points="0 0 90.83 76.66 0 153.32 0 134.82 69.49 76.66 0 18.51 0 0"
        style={{ fill: styles.fill }}
      />
      />
    </svg>
  );
};

export default AngleRight;
